import { render, staticRenderFns } from "./Dev.vue?vue&type=template&id=7359907b&scoped=true&"
import script from "./Dev.vue?vue&type=script&lang=js&"
export * from "./Dev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7359907b",
  null
  
)

export default component.exports